module.exports = __webpack_public_path__ + "img/icaon_tixian_02@2x.61f1f1b5.png";